import MDAlert from "components/MDAlert";
import { SelectOptions } from "components/Shared/CustomSelect/CustomSelect";
import {
  REFETCH_QUERY_DEFAULT_PAGE,
  REFETCH_QUERY_FIRST_VARIABLE,
} from "constants/RefetchVariables";
import { ProductGroup } from "generated/graphql";
import useGetProductGroups from "hooks/products/useGetProductGroups";
import { usePaginatedVariables } from "hooks/strings/usePaginatedVariables";
import { useMemo, memo, useEffect } from "react";
import parseGraphQLError from "utils/graphQL/parseGraphQLError";

function ProductGroupOptions({
  children,
}: {
  children: ({
    productGroupOptions,
    productGroups,
    loading,
    search,
  }: {
    productGroupOptions: SelectOptions;
    productGroups: ProductGroup[];
    loading: boolean;
    search: (v: string) => void;
  }) => React.ReactNode;
}) {
  const { filtering } = usePaginatedVariables();

  const { loading, data, error, getAllData, paginatorInfo } = useGetProductGroups({
    first: REFETCH_QUERY_FIRST_VARIABLE,
    search: filtering.debouncedSearchTerm,
    page: REFETCH_QUERY_DEFAULT_PAGE,
  });

  useEffect(() => {
    if (!loading && paginatorInfo?.total && (data?.length ?? 0) < paginatorInfo.total) {
      getAllData();
    }
  }, [data?.length, getAllData, loading, paginatorInfo?.total]);
  const productGroups = (data as ProductGroup[]) ?? [];

  const productGroupOptions = useMemo(
    () =>
      productGroups.map((productGroup) => ({
        label: productGroup.name,
        value: productGroup.id,
        productIds: productGroup.products.map((product) => product.id),
      })),
    [productGroups]
  );

  if (error) {
    return <MDAlert color="error">{parseGraphQLError(error)}</MDAlert>;
  }
  return (
    <>
      {children({ productGroupOptions, productGroups, loading, search: filtering.setSearchTerm })}
    </>
  );
}

export default memo(ProductGroupOptions);
